var map = {
	"./1.jpg": 78,
	"./2.jpg": 577,
	"./2025_1.jpg": 102,
	"./2025_2.jpg": 857,
	"./results/results-0percent.jpg": 346,
	"./results/results-100percent.jpg": 841,
	"./results/results-10percent.jpg": 859,
	"./results/results-15percent.jpg": 360,
	"./results/results-20percent.jpg": 388,
	"./results/results-25percent.jpg": 23,
	"./results/results-30percent.jpg": 33,
	"./results/results-35percent.jpg": 254,
	"./results/results-40percent.jpg": 882,
	"./results/results-45percent.jpg": 261,
	"./results/results-50percent.jpg": 655,
	"./results/results-55percent.jpg": 324,
	"./results/results-5percent.jpg": 157,
	"./results/results-60percent.jpg": 632,
	"./results/results-65percent.jpg": 779,
	"./results/results-70percent.jpg": 301,
	"./results/results-75percent.jpg": 106,
	"./results/results-80percent.jpg": 526,
	"./results/results-85percent.jpg": 334,
	"./results/results-90percent.jpg": 160,
	"./results/results-95percent.jpg": 736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;